module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_realestate_sp-ba7fe7097f377b0b27f549944b6112c1.svg";